import { TrackingPageContext } from '../../../types'

export interface TrackLogoutEvent {
  event: 'logout'
  status: 'successful' | 'error'
  content_name: string
  page_type: string
  page_type_id: string
  customer_id: undefined
  eh: undefined
}

export const trackLogout =
  ({
    status,
    page,
  }: {
    status: 'successful' | 'error'
    page: TrackingPageContext
  }) =>
  () => {
    const event: TrackLogoutEvent = {
      event: 'logout',
      status,
      content_name: page.path,
      page_type: page.type,
      page_type_id: `${page.id || ''}`,
      customer_id: undefined,
      eh: undefined,
    }

    return event
  }
